import React from 'react';
import Navbar from '../components/Common/Navbar';
import Footer from '../components/Common/Footer';
import HrServiceDetails from '../components/ServiceDetails/HrServiceDetails';

const HrServicePage = () => {
    return (
        <>
            <div className="serviceDetail_container" id="section">
                <div className="serviceDetail_bg">
                    <Navbar />
                    <div className="serviceDetail_head_container">
                        <h1 className="text-center">Strategic HR Consulting</h1>
                        <p className="serviceDetail_head_subtitle">
                            Bridging the Gap Between Your Bottom Line and Your Best Assets
                        </p>
                    </div>
                </div>
            </div>
            <HrServiceDetails />
            <Footer />
        </>
    );
};

export default HrServicePage;
